import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const RevenueChart = ({ data, currentLanguage = 'fr' }) => {
  const labels = {
    fr: {
      title: 'Revenus mensuels',
      subscriptions: 'Abonnements',
      commissions: 'Commissions',
      total: 'Total'
    },
    ar: {
      title: 'الإيرادات الشهرية',
      subscriptions: 'الاشتراكات',
      commissions: 'العمولات',
      total: 'المجموع'
    }
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-warm-md">
          <p className="font-medium text-foreground mb-2">{payload?.[0]?.payload?.month}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <span className="caption text-muted-foreground">{entry?.name}:</span>
              <span className="data-text font-medium" style={{ color: entry?.color }}>
                {entry?.value?.toLocaleString()} MAD
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">
        {labels?.[currentLanguage]?.title}
      </h3>
      <div className="w-full h-64 md:h-80" aria-label="Monthly Revenue Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              tickFormatter={(value) => `${(value / 1000)?.toFixed(0)}k`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="subscriptions" 
              name={labels?.[currentLanguage]?.subscriptions}
              fill="var(--color-primary)" 
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey="commissions" 
              name={labels?.[currentLanguage]?.commissions}
              fill="var(--color-accent)" 
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;